export const MY_APPOINTMENTS_TAB = 'myAppointments';
export const MY_PERSONAL_DATA_TAB = 'myPersonalData';
export const MY_GIFT_VOUCHERS_TAB = 'myGiftCards';
export const MY_ORDERS_TAB = 'myOrders';
